import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Globe } from 'lucide-react';

const languages = [
  { code: 'nl', name: 'Nederlands', rtl: false },
  { code: 'en', name: 'English', rtl: false },
  { code: 'de', name: 'Deutsch', rtl: false },
  { code: 'ar', name: 'العربية', rtl: true },
  { code: 'tr', name: 'Türkçe', rtl: false },
  { code: 'es', name: 'Español', rtl: false },
  { code: 'fr', name: 'Français', rtl: false }
];

function LanguageSelector({ variant = 'default' }) {
  const { i18n } = useTranslation();

  const changeLanguage = (langCode) => {
    const selectedLang = languages.find(l => l.code === langCode);
    
    i18n.changeLanguage(langCode);
    localStorage.setItem('language', langCode);
    
    // Set RTL
    if (selectedLang?.rtl) {
      document.documentElement.dir = 'rtl';
      document.documentElement.lang = langCode;
      document.body.style.direction = 'rtl';
    } else {
      document.documentElement.dir = 'ltr';
      document.documentElement.lang = langCode;
      document.body.style.direction = 'ltr';
    }
  };

  useEffect(() => {
    // Set initial RTL on mount
    const currentLang = languages.find(l => l.code === i18n.language);
    if (currentLang?.rtl) {
      document.documentElement.dir = 'rtl';
      document.body.style.direction = 'rtl';
    }
  }, [i18n.language]);

  if (variant === 'compact') {
    return (
      <button
        onClick={() => {
          const currentIndex = languages.findIndex(l => l.code === i18n.language);
          const nextIndex = (currentIndex + 1) % languages.length;
          changeLanguage(languages[nextIndex].code);
        }}
        className="flex items-center gap-2 p-2 hover:bg-gray-100 rounded transition-colors"
        data-testid="language-toggle"
      >
        <Globe className="w-4 h-4" />
        <span className="text-sm font-medium">{languages.find(l => l.code === i18n.language)?.name}</span>
      </button>
    );
  }

  return (
    <div className="flex items-center gap-2" data-testid="language-selector">
      <Globe className="w-4 h-4 text-gray-600" />
      <Select value={i18n.language} onValueChange={changeLanguage}>
        <SelectTrigger className="w-40">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {languages.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              {lang.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export default LanguageSelector;
